import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-post-change-comms';

const validator = () => null;

const vFParams = {
  paragraph: '',
};

const paragraphPostChangeComms = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphPostChangeComms };
